// extracted by mini-css-extract-plugin
module.exports = {"center-wh":"center-wh--20YrI","FarmOption":"FarmOption--23hih","Icon":"Icon--3YIS7"};